import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import { SearchIcon, LocationIcon, HomeIcon, FilterIcon } from '../components/Icons/Icons';
import './FindDreamHome.css';

function FindDreamHome() {
  const [searchParams, setSearchParams] = useState({
    purpose: 'buy',
    city: '',
    propertyType: '',
    priceMin: '',
    priceMax: '',
    bedrooms: '',
    area: ''
  });

  const cities = ['Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan'];
  const propertyTypes = ['House', 'Flat', 'Plot', 'Commercial', 'Farmhouse'];
  const bedroomOptions = ['1', '2', '3', '4', '5', '6+'];

  const handleSearch = () => {
    // Store search params and navigate to listings
    sessionStorage.setItem('searchParams', JSON.stringify(searchParams));
    if (window.navigateTo) {
      window.navigateTo('listings');
    }
  };

  return (
    <div className="find-dream-home-page">
      <Header />

      <div className="find-dream-container">
        <div className="find-hero">
          <h1>Find Your Dream Home</h1>
          <p>Search from thousands of properties across Pakistan</p>
        </div>

        <div className="find-content">
          <div className="search-wizard">
            <div className="wizard-step">
              <div className="step-header">
                <div className="step-icon-circle">
                  <SearchIcon size={24} color="#ffffff" />
                </div>
                <div>
                  <h2>Start Your Search</h2>
                  <p>Tell us what you're looking for</p>
                </div>
              </div>

              <div className="find-dream-search-form">
                <div className="form-section">
                  <label className="form-label">I want to</label>
                  <div className="toggle-group">
                    <button
                      className={`toggle-btn ${searchParams.purpose === 'buy' ? 'active' : ''}`}
                      onClick={() => setSearchParams({ ...searchParams, purpose: 'buy' })}
                    >
                      Buy
                    </button>
                    <button
                      className={`toggle-btn ${searchParams.purpose === 'rent' ? 'active' : ''}`}
                      onClick={() => setSearchParams({ ...searchParams, purpose: 'rent' })}
                    >
                      Rent
                    </button>
                  </div>
                </div>

                <div className="form-section">
                  <label className="form-label">City</label>
                  <select
                    value={searchParams.city}
                    onChange={(e) => setSearchParams({ ...searchParams, city: e.target.value })}
                    className="form-select"
                  >
                    <option value="">Select city</option>
                    {cities.map(city => (
                      <option key={city} value={city}>{city}</option>
                    ))}
                  </select>
                </div>

                <div className="form-section">
                  <label className="form-label">Property Type</label>
                  <select
                    value={searchParams.propertyType}
                    onChange={(e) => setSearchParams({ ...searchParams, propertyType: e.target.value })}
                    className="form-select"
                  >
                    <option value="">All types</option>
                    {propertyTypes.map(type => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                </div>

                <div className="form-row">
                  <div className="form-section">
                    <label className="form-label">Price Range (PKR)</label>
                    <div className="price-inputs">
                      <input
                        type="text"
                        placeholder="Min"
                        value={searchParams.priceMin}
                        onChange={(e) => setSearchParams({ ...searchParams, priceMin: e.target.value })}
                        className="form-input"
                      />
                      <span className="separator">to</span>
                      <input
                        type="text"
                        placeholder="Max"
                        value={searchParams.priceMax}
                        onChange={(e) => setSearchParams({ ...searchParams, priceMax: e.target.value })}
                        className="form-input"
                      />
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <label className="form-label">Bedrooms</label>
                  <div className="bedroom-grid">
                    {bedroomOptions.map(option => (
                      <button
                        key={option}
                        className={`bedroom-btn ${searchParams.bedrooms === option ? 'active' : ''}`}
                        onClick={() => setSearchParams({ ...searchParams, bedrooms: option })}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>

                <button className="find-dream-btn-search-main" onClick={handleSearch}>
                  <SearchIcon size={20} color="#ffffff" />
                  Search Properties
                </button>
              </div>
            </div>

            <div className="wizard-features">
              <h3>Why Choose PakMilkiyat?</h3>
              <div className="features-list">
                <div className="feature-item">
                  <div className="feature-icon">
                    <HomeIcon size={24} color="var(--color-primary)" />
                  </div>
                  <div>
                    <h4>150,000+ Properties</h4>
                    <p>Largest database of verified properties</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">
                    <LocationIcon size={24} color="var(--color-primary)" />
                  </div>
                  <div>
                    <h4>50+ Cities</h4>
                    <p>Properties across all major cities</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">
                    <FilterIcon size={24} color="var(--color-primary)" />
                  </div>
                  <div>
                    <h4>Advanced Filters</h4>
                    <p>Find exactly what you're looking for</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="popular-searches">
            <h3>Popular Searches</h3>
            <div className="search-tags">
              <button className="search-tag" onClick={() => {
                setSearchParams({ ...searchParams, city: 'Karachi', propertyType: 'House' });
              }}>
                Houses in Karachi
              </button>
              <button className="search-tag" onClick={() => {
                setSearchParams({ ...searchParams, city: 'Lahore', propertyType: 'Flat' });
              }}>
                Flats in Lahore
              </button>
              <button className="search-tag" onClick={() => {
                setSearchParams({ ...searchParams, city: 'Islamabad', propertyType: 'Plot' });
              }}>
                Plots in Islamabad
              </button>
              <button className="search-tag" onClick={() => {
                setSearchParams({ ...searchParams, city: 'Karachi', purpose: 'rent' });
              }}>
                Rent in Karachi
              </button>
              <button className="search-tag" onClick={() => {
                setSearchParams({ ...searchParams, city: 'Lahore', purpose: 'rent' });
              }}>
                Rent in Lahore
              </button>
              <button className="search-tag" onClick={() => {
                setSearchParams({ ...searchParams, propertyType: 'Commercial' });
              }}>
                Commercial Properties
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default FindDreamHome;
